import type { Format } from '../schemas/format';

/**
 * Parliamentary under CHSSA rules (Article XI §4): PMC 7, LOC 8, MGC 8, MOC 8, LOR 4, PMR 5. Government speaks
 * first and last. 20 minutes of prep before the round and none during it. Points of information only in
 * constructives, never in a speech's first or last minute; points of order (new arguments) only in rebuttals.
 */
export const PARLI_CHSSA: Format = {
  id: 'parli-chssa',
  version: 1,
  name: 'Parliamentary (CHSSA)',
  event: 'parli',
  ruleset: 'CHSSA',
  sideLabels: ['Gov', 'Opp'],
  teamSize: 2,
  order: 'fixed',
  prepSec: 0,
  graceSec: 10,
  points: { min: 25, max: 30, step: 0.1 },
  poiProtectedSec: 60,
  extensionRoles: ['final'],
  extensionNote: "An argument counts at the end if its team carried it into their rebuttal (LOR or PMR). Rebuttals can't bring new arguments, except that the PMR may answer new arguments from the MOC.",
  segments: [
    { id: 'PMC', kind: 'speech', role: 'constructive', label: 'Prime Minister Constructive', short: 'PMC', durationSec: 420, by: 'first', speakers: [1] },
    { id: 'LOC', kind: 'speech', role: 'constructive', label: 'Leader of Opposition Constructive', short: 'LOC', durationSec: 480, by: 'second', speakers: [1] },
    { id: 'MGC', kind: 'speech', role: 'constructive', label: 'Member of Government Constructive', short: 'MGC', durationSec: 480, by: 'first', speakers: [2] },
    { id: 'MOC', kind: 'speech', role: 'constructive', label: 'Member of Opposition Constructive', short: 'MOC', durationSec: 480, by: 'second', speakers: [2] },
    { id: 'LOR', kind: 'speech', role: 'final', label: 'Leader of Opposition Rebuttal', short: 'LOR', durationSec: 240, by: 'second', speakers: [1] },
    { id: 'PMR', kind: 'speech', role: 'final', label: 'Prime Minister Rebuttal', short: 'PMR', durationSec: 300, by: 'first', speakers: [1] },
  ],
  sheets: [
    { id: 'case-first', title: '{first} case', owner: 'first', segmentIds: ['PMC', 'LOC', 'MGC', 'MOC', 'LOR', 'PMR'] },
    { id: 'case-second', title: '{second} case', owner: 'second', segmentIds: ['LOC', 'MGC', 'MOC', 'LOR', 'PMR'] },
  ],
};
